import { ReactElement, useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import BulkEditDialog from './BulkEditDialog';
import PointAssignees, { TPointAssignee } from './PointAssignees';

type TBulkAssigneesDialogProps = {
  options: TPointAssignee[];
  onClose: () => void;
  onSave: (assigneeIds: string[]) => Promise<void>;
};

const BulkAssigneesDialog = ({
  options,
  onClose,
  onSave,
}: TBulkAssigneesDialogProps): ReactElement => {
  const [assignees, setAssignees] = useState<TPointAssignee[]>([]);

  const handleSave = (): Promise<void> => onSave(assignees.map((assignee) => assignee.value));

  return (
    <BulkEditDialog
      title={translate('add_assignees')}
      canSave={assignees.length > 0}
      onClose={onClose}
      onSave={handleSave}
      body={
        <PointAssignees
          assignees={{ value: assignees, canEdit: true, onSave: setAssignees }}
          options={options}
        />
      }
    />
  );
};

export default BulkAssigneesDialog;
